import * as React from 'react'
import { default as MuiMenuList, MenuListProps } from '@mui/material/MenuList'

export const MenuList = (props: MenuListProps) => {
  return <MuiMenuList {...props} />
}

export default MenuList
